import _ from "lodash";
import moment from "moment";

import {
  SET_CONTACT_PROPERTIES,
  SET_CONTACT_PROPERTY_OPTIONS,
  UNSET_CONTACT_PROPERTY_OPTIONS,
  CREATE_CONTACT_PROPERTY,
  DELETE_CONTACT_PROPERTY,
  UNSET_CONTACT_PROPERTY_ACTION,
  UPDATE_CONTACT_PROPERTY,
  ERROR_CONTACT_PROPERTY,
  UNSET_ERROR_CONTACT_PROPERTY
} from "actions/types";

const INITIAL_STATE = {
  lastAction: null,
  propertiesAvailable: {},
  propertyOptions: [],
  propertyErrors: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_CONTACT_PROPERTIES:
      return {
        ...state,
        lastAction: "fetch",
        propertiesAvailable: _.mapKeys(action.payload, "id")
      };
    case SET_CONTACT_PROPERTY_OPTIONS:
      return { ...state, propertyOptions: action.payload };
    case UNSET_CONTACT_PROPERTY_OPTIONS:
      if (state.propertyOptions) {
        return { ...state, propertyOptions: [] };
      }
      return state;
    case UNSET_CONTACT_PROPERTY_ACTION:
      return { ...state, lastAction: null };
    case CREATE_CONTACT_PROPERTY:
      const createdItem = action.payload.created_items[0];
      const { id } = createdItem;
      const newState = {
        ...state,
        lastAction: "create",
        propertiesAvailable: {
          ...state.propertiesAvailable,
          [id]: createdItem
        }
      };
      return newState;
    case UPDATE_CONTACT_PROPERTY:
      const updatedItem = (state.propertiesAvailable[
        action.currentContactProperty.id
      ] = action.currentContactProperty);
      updatedItem.updated_at = moment.utc().format("YYYY-MM-DD HH:mm:ss");
      return {
        ...state,
        lastAction: "edit",
        updatedItem
      };
    case ERROR_CONTACT_PROPERTY:
      return {
        ...state,
        propertyErrors: action.payload,
        lastAction: "error"
      };
    case UNSET_ERROR_CONTACT_PROPERTY:
      return {
        ...state,
        propertyErrors: {}
      };
    case DELETE_CONTACT_PROPERTY:
      const updated = state.propertiesAvailable;
      _.unset(updated, `${action.currentContactProperty.id}`);
      return { ...state, lastAction: "delete", propertiesAvailable: updated };
    default:
      return state;
  }
};
